interface CaseItem {
  badge: string;
  title: string;
  link: string;
  desc: string;
  tags: string[];
  result: string;
  image?: string;
}

const cases: CaseItem[] = [
  {
    badge: "自社プロダクト",
    title: "KluAI — AI学習プラットフォーム",
    link: "https://pr-i.co.jp/service/sales_promotion/kluai_lp/",
    desc: "AIと行動心理学を組み合わせた学習プラットフォームです。パートナーがアップロードしたコンテンツからAIが「ブック」形式のトレーニング教材を自動生成。ユーザーの正答率・回答速度をAIが分析し、最適な学習体験を提供します。",
    tags: ["AI自動コンテンツ生成", "決済・課金機能搭載", "パーソナライズ学習"],
    result: "AIコンテンツ自動生成 × 適応学習",
    image: "https://static.readdy.ai/image/18990d96ea38ed6d3bd5bedb9be046f1/7f23fa32d4c629f9b752083a9a7170a3.png",
  },
  {
    badge: "自社プロダクト",
    title: "CHATMAN — 社内ナレッジ管理チャット",
    link: "https://pr-i.co.jp/service/sales_promotion/chatman_lp/",
    desc: "法人向けのセキュアなチャットシステム。部署横断のやり取りやファイル共有を一元管理し、「誰が何を共有したか」を後からたどれる社内ナレッジ基盤として活用できます。チーム単位のチャットルーム管理とAES-128-GCM暗号化によるエンタープライズグレードのセキュリティで、情報を安全に蓄積できます。",
    tags: ["社内ナレッジ一元管理", "アクセス権限コントロール", "エンタープライズセキュリティ"],
    result: "社内ナレッジ蓄積 × 高度なセキュリティ",
    image: "https://static.readdy.ai/image/18990d96ea38ed6d3bd5bedb9be046f1/187e961830353c3b7cd06ecf6cab4849.png",
  },
];

export default function CaseStudies() {
  return (
    <section className="bg-gray-50 py-20">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">企画からリリースまで一貫した開発力</h2>
          <p className="text-lg font-bold text-gray-800 mb-2">弊社の開発事例です</p>
          <p className="text-gray-500 text-sm max-w-xl mx-auto leading-relaxed">
            企画からリリースまでのプロセスを一貫して構造化することで、AI開発に最適化しています。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cases.map((c) => (
            <div key={c.title} className="bg-white border border-gray-200 rounded-2xl overflow-hidden flex flex-col">
              {c.image && (
                <div className="w-full h-52 overflow-hidden relative">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-white/30 to-transparent" />
                </div>
              )}
              {!c.image && (
                <div className="w-full h-36 bg-gradient-to-br from-blue-600 to-blue-900 flex items-center justify-center">
                  <span className="text-white/30 text-5xl font-black tracking-widest select-none">
                    {c.title.split("—")[0].trim()}
                  </span>
                </div>
              )}
              <div className="p-7 flex flex-col flex-1">
                <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-3 py-1 rounded-full mb-3 whitespace-nowrap self-start">
                  {c.badge}
                </span>
                <h3 className="text-lg font-extrabold text-gray-900 mb-1">{c.title}</h3>
                <a
                  href={c.link}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-blue-600 text-sm font-semibold hover:underline cursor-pointer mb-4"
                >
                  サービスを見る &rarr;
                </a>
                <p className="text-gray-500 text-sm leading-relaxed mb-5">{c.desc}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {c.tags.map((t) => (
                    <span key={t} className="bg-gray-100 text-gray-600 text-xs px-3 py-1 rounded-full whitespace-nowrap">
                      {t}
                    </span>
                  ))}
                </div>
                <div className="mt-auto bg-blue-50 border border-blue-100 rounded-xl px-4 py-3 flex items-center gap-3">
                  <span className="text-xs text-gray-500 font-medium whitespace-nowrap">特長</span>
                  <span className="text-xs font-bold text-blue-700">{c.result}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}